var _ellipse, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoData(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 63,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.714,
    cy: 52.062,
    rx: 58.809,
    ry: 10.76,
    fill: "#F6F8FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.106 49.151v0a3.2 3.2 0 003.2-3.2v-12.8a3.2 3.2 0 00-3.2-3.2h-19.2v-3.2a3.2 3.2 0 00-3.2-3.2h-9.6 0a3.2 3.2 0 00-3.2 3.2v19.2a3.2 3.2 0 003.2 3.2h32z",
    stroke: "#9BA7E9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.706 23.551v-19.2 0a3.2 3.2 0 013.2-3.2h22.675v0a3.2 3.2 0 012.261.937l6.127 6.126v0c.6.6.937 1.414.937 2.262V39.55a3.2 3.2 0 01-3.2 3.2h-6.4M58.306 10.751h16M58.306 20.351h16",
    stroke: "#9BA7E9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgNoData;